export class GtmItemModel {
    /**
     * @type {string}
     */
    item_id = '';

    /**
     * @type {string}
     */
    item_name = '';

    /**
     * @type {string}
     */
    affiliation = 'Böckmann';

    /**
     * @type {string}
     */
    coupon = '';

    /**
     * @type {number}
     */
    discount = 0;

    /**
     * @type {number}
     */
    index = 0;

    /**
     * @type {string}
     */
    item_brand = 'Böckmann';

    /**
     * @type {null|string}
     */
    item_category = null;

    /**
     * @type {null|string}
     */
    item_variant = null;

    /**
     * @type {null|number}
     */
    price = null;

    /**
     * @type {number}
     */
    quantity = 1;

    /**
     * @returns {{}}
     */
    getitemData(index) {
        let item = {};

        item.item_id = this.item_id;
        item.item_name = this.item_name;
        item.affiliation = this.affiliation;

        if (this.coupon) {
            item.coupon = this.coupon;
        }

        if (this.discount) {
            item.discount = this.discount;
        }

        item.index = index;
        item.item_brand = this.item_brand;

        if (this.item_category) {
            item.item_category = this.item_category;
        }

        if (this.item_variant) {
            item.item_variant = this.item_variant;
        }

        if (this.price) {
            item.price = this.price;
        }

        item.quantity = this.quantity;

        return item
    }

    /**
     * @returns {boolean}
     */
    isValid() {
        if (this.item_id === '' &&
            this.item_name === ''
        ) {
            return false;
        }

        return true;
    }
}